if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.overlay = document.querySelector('.js-product-modal-overlay');
        this.keydownHandler = null;
        this.overlayClickHandler = null;
        this.variantChangeHandler = null;
        this.colorFallbackHandler = null;
      }

      connectedCallback() {
        this.addEvents();
        this.addVariantChangeListener();
      }

      disconnectedCallback() {
        if (this.keydownHandler) {
          document.removeEventListener('keydown', this.keydownHandler);
        }
        if (this.overlayClickHandler) {
          this.overlay.removeEventListener('click', this.overlayClickHandler);
        }
        if (this.variantChangeHandler) {
          document.removeEventListener('variant:change', this.variantChangeHandler);
        }
        if (this.colorFallbackHandler) {
          document.removeEventListener('variant:color-fallback', this.colorFallbackHandler);
        }
      }

      hide() {
        super.hide();

        if (this.overlay) {
          this.overlay.classList.remove('active');
        }
      }

      show(opener) {
        super.show(opener);

        if (this.overlay) {
          this.overlay.classList.add('active');
        }

        if (window.innerWidth >= 990) {
          requestAnimationFrame(() => {
            this.adjustModalContentWidth();
          });
        }
      }

      addEvents() {
        this.keydownHandler = (event) => {
          if (event.key === 'Escape') {
            this.hide();
          }
        };
        this.overlayClickHandler = () => {
          this.hide();
        };

        if (this.overlay) {
          this.overlay.addEventListener('click', this.overlayClickHandler);
        }

        document.addEventListener('keydown', this.keydownHandler);
      }

      addVariantChangeListener() {
        this.variantChangeHandler = (event) => {
          const { variant } = event.detail;
          if (variant && variant.id) {
            this.filterModalMediaByVariant(variant.id);
          }
        };

        document.addEventListener('variant:change', this.variantChangeHandler);

        this.colorFallbackHandler = (event) => {
          const { variantId } = event.detail;
          if (variantId) {
            this.filterModalMediaByVariant(variantId);
          }
        };

        document.addEventListener('variant:color-fallback', this.colorFallbackHandler);
      }

      filterModalMediaByVariant(variantId) {
        const variantIdStr = variantId.toString();
        const modalMediaItems = this.querySelectorAll('.product-media-modal__media[data-variant-id]');

        modalMediaItems.forEach((mediaItem) => {
          if (mediaItem.dataset.variantId === variantIdStr) {
            mediaItem.classList.remove('hidden');
          } else {
            mediaItem.classList.add('hidden');
          }
        });

        if (window.innerWidth >= 990) {
          this.adjustModalContentWidth();
        }
      }

      adjustModalContentWidth() {
        const modalContent = this.querySelector('.product-media-modal__content');
        if (!modalContent) return;

        let activeMedia = modalContent.querySelector('.product-media-modal__media:not(.hidden)');

        let img = null;
        if (activeMedia) {
          img = activeMedia.querySelector('img');
        } else {
          img = modalContent.querySelector('.ir img, .global-media-settings img');
        }

        if (!img) return;

        const calculateAndSetWidth = (image) => {
          const modalHeight = this.offsetHeight || window.innerHeight * 0.95;
          const availableHeight = modalHeight - 75;

          const naturalWidth = image.naturalWidth;
          const naturalHeight = image.naturalHeight;

          if (!naturalWidth || !naturalHeight) return;

          const aspectRatio = naturalWidth / naturalHeight;
          const calculatedMaxWidth = availableHeight * aspectRatio;
          modalContent.style.maxWidth = `${calculatedMaxWidth}px`;
        };

        if (img.complete && img.naturalWidth > 0) {
          requestAnimationFrame(() => calculateAndSetWidth(img));
        } else {
          const onImageLoad = () => {
            requestAnimationFrame(() => calculateAndSetWidth(img));
            img.removeEventListener('load', onImageLoad);
          };
          img.addEventListener('load', onImageLoad);
        }
      }
    },
  );
}
